import Controller from '@ember/controller';

export default class Challenge extends Controller {}
